import ManageDepot from '@/components/caisse/depot/manage-depot-modal'


export default {
    name: 'depot',
    components: {
        ManageDepot
    },
    props: [],
    data() {
        return {
            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),
            curr_month: {},
            // curr_month: {},          // Current month of the year
            filter_date: '',

            is_empty: false,
            is_loading: true,
            fields: [
                { key: 'patient', label: 'Patient' }, { key: 'montant', label: 'Total déposé' }, { key: 'montant_reverse', label: 'Total reversé' }, 
                { key: 'montant_depense', label: 'Total dépensé' }, { key: 'montant_restant', label: 'Montant restant' },
                { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,
            
            historique: {},
            depot_info: {},
            toggle_list: true,
            compte_id: 0
        }
    },

    watch: {
        curr_month() {
            if (this.curr_month['id'] > 0) {
                this.type_period = 1
                this.period = this.curr_month['id']
                var data = {
                    type_period: this.type_period,
                    period: this.period
                }
                this.getListeDepot(data)
            }
        },

        filter_date() {
            this.type_period = 2
            this.period = this.filter_date
            var data = {
                type_period: this.type_period,
                period: this.period
            }
            this.getListeDepot(data)
        }
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth(); index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        liste_depots() {
            return this.$store.getters['liste_depots']
        },

        row_depots() {
            return this.liste_depots.length
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },
    },

    mounted() {
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.curr_month = this.monthOfYear[this.date.getMonth()]

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js
    },

    methods: {
        getListeDepot(data) {
            this.is_loading = true

            this.$store.dispatch('getListeDepots', data).then(() => {
                if (this.liste_depots.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        refreshListeDepot() {
            this.type_period = 1
            this.period = this.curr_month['id']
            var data = {
                type_period: this.type_period,
                period: this.period
            }
            this.getListeDepot(data)
        },

        handleAction(historique) {
            this.historique = historique
        },

        addDepot() {
            this.toggle_list = (this.toggle_list)?false:true
        },
    }
}


